import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { FreelancerService } from '../services/freelancer.service';
import { FreelancerFilter } from '../interfaces/filters';
import { Freelancer } from '../models/freelancer';

@Injectable()
export class FreelancerStore {
  private _freelancer: BehaviorSubject<Freelancer[]> = new BehaviorSubject([]);
  private _page: BehaviorSubject<number> = new BehaviorSubject(1);
  private _total: BehaviorSubject<number> = new BehaviorSubject(0);
  private _loading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private _lastPage: BehaviorSubject<boolean> = new BehaviorSubject(false);

  private page: number;
  private total: number;
  private filter: FreelancerFilter;
  private pagecount: number;

  constructor(private freelancerBackendService: FreelancerService) {
    // this.loadInitialData(1);
  }

  get freelancers() {
    return this._freelancer.asObservable();
  }

  get currentPage() {
    return this._page.asObservable();
  }

  get getTotal() {
    return this._total.asObservable();
  }

  get loading() {
    return this._loading.asObservable();
  }

  get lastPage() {
    return this._lastPage.asObservable();
  }

  changeFilters(filters: FreelancerFilter, requirement: boolean, page: number, pagecount?: number, jobId?: string) {
    this.filter = filters;
    this.pagecount = pagecount;
    this._loading.next(true);
    this.freelancerBackendService.getFreelancer(filters, requirement, page, pagecount, jobId)
      .subscribe(
        res => {
          this.page = page;
          this.total = res.pagination.total;
          this._freelancer.next(res.freelancers);
          this._page.next(page);
          this._total.next(this.total);
          this._loading.next(false);
          this._lastPage.next(this.page >= this.maxPages());
        },
        () => {
          console.log('Error retrieving Freelancers');
          this._loading.next(false);
        }
      );
  }

  private maxPages() {
    return Math.ceil(this.total / (this.pagecount || 10));
  }

  nextPage(requirement) {
    if (this.page < this.maxPages()) {
      this.changeFilters(this.filter, requirement, this.page + 1, this.pagecount);
    }
  }

  prevPage(requirement) {
    if (this.page > 1) {
      this.changeFilters(this.filter, requirement, this.page - 1, this.pagecount);
    }
  }
}



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/state/freelancer.store.ts